import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import "./style.scss";
const columns = [
  {
    title: "Input",
    dataIndex: "name",
    key: "name",
    render: (text, render) => (
      <Link to={`/components/product/${render._id}`}>{text}</Link>
    )
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    filters: [
      { text: "12VLight", value: "12vLight" },
      { text: "SpinningMotor", value: "SpinningMotor" },
      { text: "ReverseRGBLed", value: "ReverseRGBLed" },
      { text: "clock", value: "clock" },
      { text: "calendar", value: "calendar" }
    ],
    onFilter: (value, record) => {
      return record.type === value;
    }
  },
  {
    title: "Label",
    dataIndex: "label",
    key: "label"
  },
  {
    title: "Speed",
    dataIndex: "speed",
    key: "speed"
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <span>
        <Link to={`/components/show/${record._id}`}>Show</Link>
        <Divider type="vertical" />
        <Link to={`/components/edit/${record._id}`}>
          <Button type="primary">Edit</Button>
        </Link>
      </span>
    )
  }
];

function App() {
  const [response, setResponse] = useState([]);
  // const data = React.useMemo(() => makeData(20), [])
  useEffect(() => {
    Axios.get(baseUrl + "components")
      .then(response => {
        setResponse(response.data);
      })
      .catch(function(error) {});
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "50px 0"
        }}
      >
        <Link to="/components/create">
          <Button type="primary" ghost>
            Create New Component
          </Button>
        </Link>
      </div>
      <Table key={"componentsTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
